<template>
  <div class="file-upload-form">
    <div class="file-upload-form__header">
      <span> Send us your headshot for our network page. </span>
      <v-btn class="close" @click="close" icon>
        <v-icon large color="#fff">$close</v-icon>
      </v-btn>
      <div class="file-upload-form__header-desc">
        We’re thrilled to connect you to others and see your photos!
      </div>
    </div>

    <v-form>
      <br />
      <Uploader
        placeholder-title="CLICK TO UPLOAD YOUR OWN PHOTO HERE"
        placeholder-desc="Files may not exceed 100mb"
        v-model="fileSource"
      />
      <br />
      <v-btn class="btn-submit" color="blue" @click="submit">Submit</v-btn>
    </v-form>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";

export default {
  name: "FileUploadForm",
  extends: formMixin,
  data() {
    return {
      fileSource: undefined
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      if (!this.fileSource) {
        return this.$alert("Please upload your photo!", "error");
      }

      this.$emit("upload", this.fileSource);
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.file-upload-form {
  position: relative;
  background-color: $stjude-purple;

  form {
    padding: 0 60px 60px;
    text-align: center;
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 50px 0px 30px;
    max-width: 850px;
    margin: 0 auto;
    font-weight: 800;
    font-size: 64px;
    line-height: 1.14;
    text-align: center;
    color: #ffffff;

    &-desc {
      margin-top: 30px;
      font-weight: normal;
      font-size: 18px;
      line-height: 24px;
    }
  }

  .btn-submit {
    margin-top: 40px;
    color: white !important;
  }
}

@media screen and (max-width: 960px) {
}
</style>
